import { render, staticRenderFns } from "./AppStoreButton.vue?vue&type=template&id=095408fc&scoped=true"
import script from "./AppStoreButton.js?vue&type=script&lang=js&external"
export * from "./AppStoreButton.js?vue&type=script&lang=js&external"
import style0 from "./AppStoreButton.scss?vue&type=style&index=0&id=095408fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095408fc",
  null
  
)

export default component.exports